import { render, staticRenderFns } from "./medecin.vue?vue&type=template&id=a9566970&scoped=true&"
import script from "./medecin.vue?vue&type=script&lang=js&"
export * from "./medecin.vue?vue&type=script&lang=js&"
import style0 from "./medecin.vue?vue&type=style&index=0&id=a9566970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9566970",
  null
  
)

export default component.exports